import {
  Component,
  ComponentInterface,
  h,
  Host,
  Prop,
} from '@stencil/core';

import { InterfacePafIcon } from '../paf-icon/paf-icon.custom';

@Component({
  shadow: false,
  styleUrl: 'paf-result-legend-item.scss',
  tag: 'paf-result-legend-item',
})

export class PafResultLegendItem implements ComponentInterface {

  /** The name of the icon to use */
  @Prop() public iconName!: string;

  /** Define the icon variant */
  @Prop() public iconVariant!: InterfacePafIcon['variant'];

  /** The description to show next to the icon */
  @Prop() public description!: string;

  /** In some cases (level 2 leg details) we want to use
   * the structure without the role='listitem' attribute
  */
  @Prop() public renderWithoutRole?: boolean;

  public render(): HTMLDivElement {
    return (
      <Host
        class={{
          'list-item': true,
          [`list-item--${this.iconVariant}`]: true,
        }}
        role={
          this.renderWithoutRole
            ? undefined
            : 'listitem'
        }
      >
        <paf-icon
          variant={this.iconVariant}
          name={this.iconName}
          data-testid='icon'
          aria-hidden='true'
          role='presentation'
        />

        <span
          data-testid='text'
          innerHTML={this.description}
          class='content'
        />
      </Host>
    );
  }
}
